//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { RadioItem } from '@campaigns/components/shared/CampaignRequestRadioField';
import { SAMPLING_CAMPAIGNS_TRACKING_ID } from '@campaigns/constants/sampling/SamplingCampaignsTrackingId';

export const getShippingManagerOptions = (clientName: string): RadioItem[] => [
  {
    value: 'bazaarvoice',
    label: 'Bazaarvoice',
    trackingId:
      SAMPLING_CAMPAIGNS_TRACKING_ID.CREATE_CAMPAIGN_SHIPPED_BV_RADIO_ITEM,
  },
  {
    value: 'myCompany',
    label: `Client-provided (${clientName})`,
    trackingId:
      SAMPLING_CAMPAIGNS_TRACKING_ID.CREATE_CAMPAIGN_SHIPPED_CLIENT_RADIO_ITEM,
  },
];

export const getCouponCodeProviderOptions = (
  clientName: string,
): RadioItem[] => [
  {
    value: 'bazaarVoice',
    label: 'Bazaarvoice',
    trackingId:
      SAMPLING_CAMPAIGNS_TRACKING_ID.CREATE_CAMPAIGN_DEALS_BV_RADIO_ITEM,
  },
  {
    value: 'client',
    label: `Client-provided (${clientName})`,
    trackingId:
      SAMPLING_CAMPAIGNS_TRACKING_ID.CREATE_CAMPAIGN_DEALS_CLIENT_RADIO_ITEM,
  },
];
